exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg[data-v-3609193f]{width:100%;height:100%;position:fixed;top:0;left:0;background:url(/static/login-background.svg) no-repeat 50%;background-size:cover}.border[data-v-3609193f]{border-width:2px!important;border-style:solid!important;border-radius:8px!important}.footer-fixed[data-v-3609193f]{position:fixed;left:0;width:100%;z-index:1}", ""]);

// exports
